const checkArray = value => (Array.isArray(value) ? value : []);

const normalizeAssignmentIdentityValue = value =>
	value === undefined || value === null ? null : String(value);

export const getUserAssignmentIdentity = ({ id, entityId } = {}) =>
	JSON.stringify([
		normalizeAssignmentIdentityValue(id),
		normalizeAssignmentIdentityValue(entityId),
	]);

export const getUniqueUserAssignments = userAssignments => {
	const identities = new Set();
	return checkArray(userAssignments).filter(userAssignment => {
		const identity = getUserAssignmentIdentity(userAssignment);
		if (identities.has(identity)) return false;
		identities.add(identity);
		return true;
	});
};

export const groupOrdersByService = orders => {
	const groupsByService = new Map();

	checkArray(orders).forEach(order => {
		const identity = normalizeAssignmentIdentityValue(order?.serviceId);
		const existingGroup = groupsByService.get(identity);
		if (existingGroup) {
			existingGroup.orders.push(order);
			return;
		}

		groupsByService.set(identity, {
			serviceId: order?.serviceId,
			orders: [order],
		});
	});

	return Array.from(groupsByService.values());
};

export const MAX_BULK_EVENT_ORDERS = 10;

export const getCommonUserAssignments = assignmentResponses => {
	const responses = checkArray(assignmentResponses);
	if (!responses.length) return [];

	const assignments = responses.map(response =>
		getUniqueUserAssignments(response?.userAssignment),
	);
	if (assignments.some(options => options.length === 0)) return [];

	const commonIdentities = assignments
		.slice(1)
		.map(options => new Set(options.map(getUserAssignmentIdentity)));

	return assignments[0].filter(option =>
		commonIdentities.every(identities =>
			identities.has(getUserAssignmentIdentity(option)),
		),
	);
};

export const getUserAssignmentCompatibilityMessage = rows => {
	const services = checkArray(rows).map(row => row?.serviceId);
	if (services.some(serviceId => serviceId === undefined || serviceId === null))
		return 'Todas las órdenes deben tener un servicio para cambiar el técnico';
};

export const buildUserAssignmentOrders = (
	rows,
	assignedTechId,
	assignedTechEntityId,
) =>
	checkArray(rows).map(row => ({
		...row,
		assignedTechId,
		// row.entityId is legacy order context; this is the selected authorization.
		...(assignedTechEntityId === undefined || assignedTechEntityId === null
			? {}
			: { assignedTechEntityId }),
	}));

export const buildEventAssignmentOrders = rows =>
	checkArray(rows).map(({ id }) => ({ id }));

export const getEventAssignmentValidationMessage = ({
	option,
	rows,
	reprogramDate,
	reprogramTime,
}) => {
	if (rows.length > MAX_BULK_EVENT_ORDERS)
		return `Solo puedes cambiar el evento de hasta ${MAX_BULK_EVENT_ORDERS} órdenes a la vez`;
	if (option.props?.reprogram && (!reprogramDate || !reprogramTime))
		return 'Te falta completar campos requeridos (*)';
};
